import { Box, FormControl, FormControlLabel, Radio, RadioGroup, styled, Typography } from "@mui/material"
import { TooltipCC } from "components/common"
import { color } from "theme"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const MINUTE = {
    NO_TIME: 0,
    5: 300,
    10: 600,
    30: 1800
}

const InfoOutlinedIconCC = styled(InfoOutlinedIcon)({
    fontSize: 18,
    color: color.grey01
})

const FormControlLabelCC = styled(FormControlLabel)({
    '& .Mui-disabled': {
        "&.MuiRadio-root": {
            color: 'rgba(0, 0, 0, 0.26) !important'
        },
    }
})

export const NoticeEndRoom = ({t, data, setData, pageDetail }) => {

    return (
        <Box sx={{marginLeft: '20%'}}>
            <Box sx={{ paddingBottom: '15px', display: 'flex' }}>
                <Typography fontWeight={700} color={theme => theme.palette.text[700]}>{t('room.settings.end-meeting.title')} <TooltipCC placement="top-start" title={t('room.settings.notice-end-room')}><InfoOutlinedIconCC /></TooltipCC>:</Typography>
            </Box>
            <FormControl>
                <RadioGroup
                    row
                    value={parseInt(data?.noticeTimeEndRoom)}
                    sx={{display: "flex", flexDirection: 'column'}}
                    onChange={(event) =>{
                        setData({
                            ...data,
                            noticeTimeEndRoom: parseInt(event.target.value)
                        })
                    }
                    }
                >
                    <FormControlLabelCC
                        disabled={pageDetail}
                        tabIndex={0}
                        value={MINUTE[5]}
                        control={<Radio size="small" />}
                        label={t('room.settings.end-meeting.minute', { num: 5 })}
                        sx={{ marginRight: "0", fontWeight: '500' }}
                        onKeyUp={(e) => {
                            if(e.code === "Enter") {
                                e.preventDefault();
                                setData({
                                    ...data,
                                    noticeTimeEndRoom: MINUTE[5]
                                })
                            }
                        }}
                    />
                    <FormControlLabelCC
                        disabled={pageDetail}
                        tabIndex={0}
                        value={MINUTE[10]}
                        control={<Radio size="small" />}
                        label={t('room.settings.end-meeting.minute', { num: 10 })}
                        sx={{ marginRight: "0", fontWeight: '500' }}
                        onKeyUp={(e) => {
                            if(e.code === "Enter"){
                                e.preventDefault();
                                setData({
                                    ...data,
                                    noticeTimeEndRoom: MINUTE[10]
                                })
                            }
                        }}
                    />
                    <FormControlLabelCC
                        disabled={pageDetail}
                        tabIndex={0}
                        value={MINUTE[30]}
                        control={<Radio size="small" />}
                        label={t('room.settings.end-meeting.minute', { num: 30 })}
                        sx={{ marginRight: "0", fontWeight: '500' }}
                        onKeyUp={(e) => {
                            if(e.code === "Enter"){
                                e.preventDefault();
                                setData({
                                    ...data,
                                    noticeTimeEndRoom: MINUTE[30]
                                })
                            }
                        }}
                    />
                    <FormControlLabelCC
                        disabled={pageDetail}
                        tabIndex={0}
                        value={MINUTE.NO_TIME}
                        control={<Radio size="small" />}
                        label={<span style={{fontWeight: '500'}}>{t('room.settings.end-meeting.no-notice')}</span>}
                        sx={{ marginRight: "0", fontWeight: '500' }}
                        onKeyUp={(e) => {
                            if(e.code === "Enter"){
                                e.preventDefault();
                                setData({
                                    ...data,
                                    noticeTimeEndRoom: MINUTE.NO_TIME
                                })
                            }
                        }}
                    />
                </RadioGroup>
            </FormControl>
        </Box>
    )
}